<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Rezervovaný příkon
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualReservedPowerChange.reservedPower || missingValueString }} kW
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín změny
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormatting(individualReservedPowerChange.requiredChangeDate) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Revizní zpráva
      </v-col>

      <v-col cols="9" class="request-value">
        <a @click.prevent="fileDownload($event)">
          {{
            file.name || missingValueString
          }}
        </a>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'IndividualReservedPowerChangeInsertedValues',
  mixins: [downloadFile],
  props: {
    individualReservedPowerChange: {
      type: Object,
      required: false,
    },
    file: {
      type: Object,
      required: false,
    },
  },
  methods: {
    fileDownload(event) {
      this.downloadFile(event, `requests/files/${this.file.uuid}`);
    },
  },
};
</script>
